import React from "react";
import DasboardHeaderMockup from "./DasboardHeaderMockup";
import DasboardLeadingSectionMockup from "./DasboardLeadingSectionMockup";
import { Box } from "@chakra-ui/core";
import DashboardBodyHeaderMockup from "./DashboardBodyHeaderMockup";
// import DashboardBodyMain from "../../components/dashboard/DashboardBodyMain";
import DashboardDataMockup from "./DasboardDataMockup"


function DashboardMockup() {

  return (
    <Box opacity=".85" px="12px" m="auto" maxWidth="900px" >
        <DasboardHeaderMockup />
        <DasboardLeadingSectionMockup />
        <DashboardBodyHeaderMockup />
        <DashboardDataMockup />
    </Box>
  );
}

export default DashboardMockup;
